const validate = values => {
    const errors = {};

    if (!values.users || !values.users.length) {
        errors.users = { _error: "At least one user must be entered" };
    } else {
        const usersArrayErrors = []
        values.users.forEach((user, index) => {
            const userErrors = {};

            if (!user || !user.firstName) {
                userErrors.firstName = 'Required'
                usersArrayErrors[index] = userErrors
            }

            if (!user || !user.lastName) {
                userErrors.lastName = 'Required'
                usersArrayErrors[index] = userErrors
            }

            if (!user || !user.email) {
                userErrors.email = 'Required'
                usersArrayErrors[index] = userErrors
            }
        });

        if (usersArrayErrors.length) {
            errors.users = usersArrayErrors
        }
    }

    return errors;
}

export default validate;